import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { type Command as CommandPrimitive, useCommandState } from 'cmdk';
import * as React from 'react';
function CommandEmpty(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const render = useCommandState(_temp);
  if (!render) {
    return null;
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("px-2 py-4 text-center text-sm", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div className={t1} cmdk-empty="" role="presentation" {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(state) {
  return state.filtered.count === 0;
}
CommandEmpty.displayName = 'CommandEmpty';
export { CommandEmpty };